/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardComponentGroupSummary from './DashboardComponentGroupSummary';

/**
* The DashboardCompanySummaryComponent model module.
* @module model/DashboardCompanySummaryComponent
* @version 2020-12-7
*/
export default class DashboardCompanySummaryComponent {
    /**
    * Constructs a new <code>DashboardCompanySummaryComponent</code>.
    * @alias module:model/DashboardCompanySummaryComponent
    * @class
    * @param type {module:model/DashboardCompanySummaryComponent.TypeEnum} 
    * @param lastUpdateDate {Number} 
    * @param weekly {Array.<module:model/DashboardComponentGroupSummary>} 
    * @param monthly {Array.<module:model/DashboardComponentGroupSummary>} 
    */

    constructor(type, lastUpdateDate, weekly, monthly) {
        
        
        this['type'] = type;
        this['lastUpdateDate'] = lastUpdateDate;
        this['weekly'] = weekly;
        this['monthly'] = monthly;
        
    }

    /**
    * Constructs a <code>DashboardCompanySummaryComponent</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardCompanySummaryComponent} obj Optional instance to populate.
    * @return {module:model/DashboardCompanySummaryComponent} The populated <code>DashboardCompanySummaryComponent</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardCompanySummaryComponent();
                        
            
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('lastUpdateDate')) {
                obj['lastUpdateDate'] = ApiClient.convertToType(data['lastUpdateDate'], 'Number');
            }
            if (data.hasOwnProperty('weekly')) {
                obj['weekly'] = ApiClient.convertToType(data['weekly'], [DashboardComponentGroupSummary]);
            }
            if (data.hasOwnProperty('monthly')) {
                obj['monthly'] = ApiClient.convertToType(data['monthly'], [DashboardComponentGroupSummary]);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/DashboardCompanySummaryComponent.TypeEnum} type
    */
    'type' = undefined;
    /**
    * @member {Number} lastUpdateDate
    */
    'lastUpdateDate' = undefined;
    /**
    * @member {Array.<module:model/DashboardComponentGroupSummary>} weekly
    */
    'weekly' = undefined;
    /**
    * @member {Array.<module:model/DashboardComponentGroupSummary>} monthly
    */
    'monthly' = undefined;



    /**
    * Allowed values for the <code>type</code> property.
    * @enum {String}
    * @readonly
    */
    static TypeEnum = {
        /**
         * value: "CompanySummary"
         * @const
         */
        "CompanySummary": "CompanySummary"    };

}
